import { IBaseFilterParameter, BaseFilterParameter } from '../base-filter.parameter';

export interface ITicketParameter extends IBaseFilterParameter {
  pb_type?: string[];
  fk_ticket_character_problem?: number[];
  apartment?: number | number[];
  block?: number[];
  actors?: number[];
  key?: string;
  typeKey?: string;
  typeValue?: string;
  visibility?: "self" | "park" | "agency" | null;
  priority?:number[],
  equipment?:number[],
  apartmentZone?: number[]
}

export class TicketParameter extends BaseFilterParameter {
  pb_type?: string[];
  fk_ticket_character_problem?: number[];
  block?: number[];
  apartment?: number | number[];
  actors?: number[];
  key?: string;
  typeKey?: string;
  typeValue?: string;
  visibility?: "self" | "park" | "agency";
  priority?:number[];
  equipment?:number[];
  apartmentZone?: number[];
  constructor(opt: ITicketParameter = {}) {
    super({ state: opt.state });
    Object.assign(this, opt)
  }
}



// WEBPACK FOOTER //
// ./src/models/ticket/ticket.parameter.ts